import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import Typography from '@/ui/components/typography'

export const Container = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;

    .title {
        color: ${({ theme: { colors } }) => colors.greys[500]};
    }

    color: ${({ theme: { colors } }) => colors.greys[800]};
`

export const List = styled('div')`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 8px;
    row-gap: 4px;
`

export const Divider = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme.colors.greys[400]};
`
